import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { RouterContext } from '@/shared/services'
import { NotFoundPage, RouteErrorPage } from '@/widgets/app-errors'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
  errorComponent: RouteErrorPage,
})

function RootLayout() {
  return <Outlet />
}
